import React from 'react';
import './TripItinerary.css';

function TripItinerary({ tour }) {
  if (!tour.itinerary || tour.itinerary.length === 0) {
    return null;
  }

  return (
    <section className="trip-itinerary">
      <div className="trip-itinerary-container">
        <h2 className="trip-section-title">Itinerary</h2>
        <div className="trip-itinerary-timeline">
          {tour.itinerary.map((day, index) => (
            <div key={index} className="trip-itinerary-day">
              <div className="trip-itinerary-day-number">
                <span>Day {day.day}</span>
              </div>
              <div className="trip-itinerary-day-content">
                <h3 className="trip-itinerary-day-title">{day.title}</h3>
                <p className="trip-itinerary-day-description">{day.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TripItinerary;

